/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // tag every line so regios applies its discounts while the theme setting is on
    if (regiosDiscount) {
        const items = formData.items || [formData];
        items.forEach(function (item) {
            item.properties = Object.assign({}, item.properties, {_regios_discount: "true"});
        });
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

function attachTemplateProperty(formData, section) {
    const tmpl = section && section.dataset.template;
    if (!tmpl) {
        return formData;
    }
    const allowedEl = section.querySelector("[data-allowed-plan-ids]");
    const allowedPlanIds = String(
        (allowedEl && allowedEl.dataset.allowedPlanIds) || section.dataset.allowedPlanIds || ""
    ).trim();
    (formData.items || []).forEach(function (item) {
        const props = {_template: tmpl};
        if (allowedPlanIds) {
            props._allowed_plan_ids = allowedPlanIds;
        }
        item.properties = Object.assign({}, item.properties, props);
    });
    return formData;
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// apply a discount code to the cart, keeping any codes already applied, and confirm it stuck
async function applyDiscountCode(code) {
    const matches = (currentCart) => currentCart.discount_codes.some((item) => {
        return item.code.toLowerCase() === code.toLowerCase() && item.applicable === true;
    });

    // combine existing applicable codes with the new one (Shopify expects a comma separated list)
    cart = await getCart();
    const codes = cart.discount_codes.filter(item => item.applicable).map(item => item.code);
    codes.push(code);
    cart = await updateCart({discount: codes.join(",")});

    // cart/update.js resolves before the discount engine settles, so re-fetch until the code shows as applicable
    for (let attempt = 0; attempt < 3 && !matches(cart); attempt++) {
        await sleep(300);
        cart = await updateCart({discount: codes.join(",")});
    }

    return matches(cart);
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Auto apply discount code

if (maltertechParams.get("coupon_code")) {
    (async function () {
        const discountCode = maltertechParams.get("coupon_code");

        const applied = await applyDiscountCode(discountCode);

        // // Apply
        // try {
        //     cart = await updateCart({discount: discounts})
        // } catch (error) {
        //     console.error(error)
        //     Swal.fire({
        //         icon: "error",
        //         title: "Whoops!",
        //         text: "We couldn't apply that discount code. Please reach out to hello@cheershealth.com for support.",
        //     });
        // }
    })();
}

/**************
 Tag existing cart lines for regios
 ***************/

// carts filled before the setting was on are missing the property, so tag them on the first page of a visit
async function tagCartForRegios() {
    // only while the theme setting is on
    if (!regiosDiscount) {
        return;
    }

    // only on the first page of the visit, later lines come through addProduct already tagged
    if (sessionStorage.getItem("regios_cart_tagged")) {
        return;
    }
    sessionStorage.setItem("regios_cart_tagged", "true");

    // nothing to tag in an empty cart
    if (cart.item_count === 0) {
        return;
    }

    // one change at a time, since each change.js call rewrites the cart and a later call must see the result
    for (const item of cart.items) {
        // already tagged
        if (item.properties && item.properties._regios_discount) {
            continue;
        }

        // change.js replaces the properties, so keep the ones already on the line
        const formData = {
            id: item.key,
            quantity: item.quantity,
            properties: Object.assign({}, item.properties, {_regios_discount: "true"}),
        };

        // keep the subscription on the line
        if (item.selling_plan_allocation) {
            formData.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }

        cart = await changeCart(formData);
    }
}

tagCartForRegios();

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

// Quick add
document.querySelectorAll(".quickAdd")?.forEach((button) => {
    button.addEventListener("click", async () => {
        button.classList.add("loading");

        const subscribed = button.classList.contains("sub");
        let formData = {items: []};

        if (button.dataset.upsellItems) {
            JSON.parse(button.dataset.upsellItems).forEach(function (upsellItem) {
                const variantID = parseInt(upsellItem.id, 10);
                if (variantID) {
                    formData.items.push({quantity: 1, id: variantID});
                }
            });
        } else if (button.dataset.bundle && !button.closest(".productProtectRedesignV1")) {
            // bundle: add each component product in place of the base product, swapping to its subscription variant on the subscribe button
            const bundleProducts = JSON.parse(button.dataset.bundle);
            bundleProducts.forEach(bundleProduct => {
                let item = {quantity: 1, id: bundleProduct.otp_id};

                // swap to the component's own subscription variant when subscribing and it has one
                if (subscribed && bundleProduct.sub_id) {
                    item.id = bundleProduct.sub_id;
                    item.selling_plan = bundleProduct.plan;
                }

                formData.items.push(item);
            });
        } else {
            // single product
            const variantID = button.dataset.variantId;
            const sellingPlan = button.dataset.sellingPlan;
            const planQuantity = parseInt(button.dataset.quantity, 10);
            const lineQuantity = Number.isFinite(planQuantity) && planQuantity > 0 ? planQuantity : 1;
            formData.items.push({quantity: lineQuantity, id: parseInt(variantID)});

            if (subscribed && sellingPlan !== "") {
                formData.items[0].selling_plan = parseInt(sellingPlan);
            }
        }

        if (!formData.items.length) {
            button.classList.remove("loading");
            return;
        }

        const templateSection = button.closest("[data-template]");
        if (templateSection && !button.classList.contains("productProtectRedesignV1UpsellAdd")) {
            attachTemplateProperty(formData, templateSection);
        }

        console.log(formData);
        // add product
        await addProduct(formData);

        // remove loading animation
        button.classList.remove("loading");

        // open cart
        await openCart();
    });
});